export function toURL(location) {
  return {
    path: toPath(location.pathname),
    ...location,
  }
}

export function toPath(pathname) {
  const paths = pathname ? pathname.split(/\//) : []
  return paths.filter(path => path !== '')
}



// WEBPACK FOOTER //
// ./src/modules/router/index.js